import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Link } from "@reach/router";
import { utilLoopHelper } from "../utils";
import PodcastItem from "./PodcastItem";

class HomePodcast extends Component {
  setCurrentAudio = (item) => {
    this.currentAudio = item;
  };

  stopCurrentAudio = () => {
    if (this.currentAudio) {
      this.currentAudio.stop();
    }
  };

  componentWillUnmount() {
    if (this.currentAudio) {
      this.currentAudio.stop();
    }
  }

  render() {
    return (
      <>
        <div className="home-podcast-wrapper">
          <div className="home-podcast">
            <h2>Yuk dengerin podcastnya {this.props.nick}</h2>
            <div className="hp-inner">
              <ul>
                {utilLoopHelper(this.props.data.items, (item, index) => {
                  return (
                    <PodcastItem
                        artist={this.props.artist}
                      key={"pdc" + index}
                      data={item}
                      fnCurrentAudio={this.setCurrentAudio}
                      fnStopCurrentAudio={this.stopCurrentAudio}
                    />
                  );
                })}
              </ul>
            </div>
          </div>
          <Link className="more" to="../podcast">
            <span>Podcast lainnya dari {this.props.nick} disini</span>
            <span>
              <img src="http://resources.triyakom.com/mini_portal/right-chevron.png" />
            </span>
          </Link>
        </div>
      </>
    );
  }
}

export default HomePodcast;
